// Feature 4 Prepared Day — the curtain's data source (/api/attention/v1).
// Pull-only: revealing and adopting are the user's acts (F4 §5).

export interface PreparedEntry {
  id: number
  entry_role: 'ACTION' | 'STRUCTURE_INVITATION' | 'CONVERSATION_INVITATION'
  rank: number
  reason_code: string
  placement: string | null
  display_title: string
  group_title: string | null
  source_item_id: number | null
  source_item_type: string | null
  canonical_item_id: number | null
  canonical_item_type: string | null
  day_state: string
}

export interface PreparedDay {
  exists: boolean
  disabled?: boolean
  plan?: {
    id: number
    local_date: string
    mode: 'normal' | 'cold_start'
    revealed_at: string | null
  }
  entries?: PreparedEntry[]
}

const base = '/api/attention/v1'

async function j<T>(res: Response): Promise<T> {
  if (!res.ok) throw new Error(`prepared-day request failed: ${res.status}`)
  return res.json() as Promise<T>
}

export async function getPreparedDay(): Promise<PreparedDay> {
  return j(await fetch(`${base}/prepared-day`, { credentials: 'include' }))
}

export async function revealPreparedDay(): Promise<void> {
  await fetch(`${base}/prepared-day/reveal`, { method: 'POST', credentials: 'include' })
}

export async function rebuildPreparedDay(): Promise<PreparedDay> {
  return j(await fetch(`${base}/prepared-day/build`, { method: 'POST', credentials: 'include' }))
}

export interface AdoptResult {
  success: boolean
  entry_role: string
  next_step?: 'focus' | 'open_journey_flow' | 'open_chat'
  item_type?: string
  item_id?: number
  added_to_focus?: boolean
  activated_via_rationing?: boolean
}

export async function adoptEntry(entryId: number): Promise<AdoptResult> {
  return j(await fetch(`${base}/prepared-day/entries/${entryId}/adopt`, {
    method: 'POST', credentials: 'include',
  }))
}

export async function skipEntry(entryId: number): Promise<void> {
  await fetch(`${base}/prepared-day/entries/${entryId}/skip`, {
    method: 'POST', credentials: 'include',
  })
}
